import { Link } from 'react-router-dom';

import { useAuth } from '../app/AuthProvider';
import { PageLoader } from '../shared/ui/PageLoader';

import { HomePage } from './HomePage';
import s from './NotFoundPage.module.css';

/**
 * The `*` catch-all.
 *
 * It used to render the marketing <HomePage> unconditionally, which meant any
 * dead in-app link (a notification pointing at a route that hadn't shipped yet)
 * dropped a signed-in user onto a page with "Log in" and "Get started" in the
 * nav — indistinguishable from having been logged out. The session was fine;
 * only the screen lied. Anonymous visitors still get the marketing page, since
 * a stray URL there is genuinely just "wrong address, here's the front door".
 */
export function NotFoundPage(): JSX.Element {
  const { user, loading } = useAuth();

  if (loading) return <PageLoader label="Loading…" />;
  if (user === null) return <HomePage />;

  return (
    <div className={s.root}>
      <div className={s.card}>
        <span className={s.code}>404</span>
        <h1 className={s.title}>We couldn’t find that page</h1>
        <p className={s.body}>
          You’re still signed in — the link just points somewhere that doesn’t exist. Head back to
          your workspace and carry on.
        </p>
        <Link to="/app" className={s.action}>
          Back to my workspace →
        </Link>
      </div>
    </div>
  );
}
